type CacheEntry<T> = { value: Promise<T>; expiresAt: number }

export function createTtlCache<T>(ttlMs: number, maxEntries = 1000) {
  const entries = new Map<string, CacheEntry<T>>()

  const evict = () => {
    const now = Date.now()
    for (const [key, entry] of entries) if (entry.expiresAt <= now) entries.delete(key)
    while (entries.size > maxEntries) {
      const oldest = entries.keys().next().value
      if (oldest === undefined) break
      entries.delete(oldest)
    }
  }

  return {
    get(key: string, load: () => Promise<T>): Promise<T> {
      const existing = entries.get(key)
      if (existing && existing.expiresAt > Date.now()) return existing.value

      const entry: CacheEntry<T> = {
        value: load().catch((error) => {
          if (entries.get(key) === entry) entries.delete(key)
          throw error
        }),
        expiresAt: Date.now() + ttlMs,
      }
      entries.set(key, entry)
      evict()

      return entry.value
    },
    delete(key: string) {
      entries.delete(key)
    },
  }
}
